module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-snapshot-add-d14e36e54fc76ab49ac5459be5736d33.svg";